import store from '../store';

export const getTutorsReducer = (state = store) => state.tutorsReducer

export const getTutorsCategories = (state = store) => getTutorsReducer(state).categories
export const getTutorsSubCategories = (state = store) => getTutorsReducer(state).subCategories
